import ILocal from "./local";
import IUser from "./user";

export interface IRoute {
    id: number;
    name: string;
    propertyGroupName: string;
    propertyGroupId: number;
    locals: ILocal[];
    localIdPositions: ILocalIdPosition[];
    users: IUser[];
    startTime?: string | null;
    endTime?: string | null;
}

export interface IRouteCreate {
    name: string;
    propertyGroupId: number;
    localIdPositions: ILocalIdPosition[];
    userIds: number[];
    startTime?: string | null;
    endTime?: string | null;
}

export interface IRouteUpdate {
    id: number;
    name?: string;
    propertyGroupId?: number;
    localIdPositions: ILocalIdPosition[];
    userIds: number[];
    startTime?: string | null;
    endTime?: string | null;
}

export interface ILocalIdPosition {
    localId: number;
    position: number;
}

export const DEFAULT_ROUTE_CREATE: IRouteCreate = {
    name: "",
    propertyGroupId: -1,
    localIdPositions: [],
    userIds: [],
    startTime: null,
    endTime: null,
};
